"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Telemetry = exports.ConnectionHistoryEvent = exports.OtaUpdate = exports.Event = exports.Alarm = exports.UserDispense = exports.InstallationUpdate = exports.AlarmStatus = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Azure = __importStar(require("../../azure"));
const date_1 = require("../../date");
const entity_1 = require("../../entity");
const Job = __importStar(require("../job"));
const User = __importStar(require("../user"));
const EventCapability = __importStar(require("./capability/event"));
const class_1 = require("./class");
const Device = __importStar(require("./class/base"));
const common_1 = require("./class/common");
const Ota = __importStar(require("./ota"));
exports.NAMESPACE = 'Culligan.Device.History';
exports.AlarmStatus = effect_1.Schema.Literal('active', 'resolved', 'dismissed').annotations({
    identifier: `${exports.NAMESPACE}.AlarmStatus`,
});
exports.InstallationUpdate = effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    deviceId: common_1.Id,
    status: effect_1.Schema.NullOr(Device.InstallationStatus),
    statusUpdatedAt: effect_1.Schema.optionalWith(effect_1.Schema.DateFromNumber, {
        exact: true,
        nullable: true,
        as: 'Option',
    }),
})).annotations({
    identifier: `${exports.NAMESPACE}.InstallationUpdate`,
    description: 'Installation status update entry for a device',
});
exports.UserDispense = effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    id: User.RelationId,
    userId: User.Id,
    deviceId: common_1.Id,
    water: effect_1.Schema.propertySignature(EventCapability.DispensedWater).annotations({
        description: 'Details of the dispensed water',
    }),
    enhancements: effect_1.Schema.propertySignature(effect_1.Schema.Array(EventCapability.DispensedEnhancement)).annotations({
        description: 'Details of any water enhancements',
    }),
    loyaltyPrograms: effect_1.Schema.propertySignature(effect_1.Schema.Array(User.Loyalty.LoyaltyProgramId)).annotations({
        description: 'Any Loyalty Programs that the event counts toward',
    }),
})).annotations({
    identifier: `${exports.NAMESPACE}.UserDispense`,
    description: 'Item from the history of dispensing events for a User',
});
exports.Alarm = effect_1.Schema.extend(class_1.ActiveAlarm.ActiveAlarm, effect_1.Schema.Struct({
    deviceId: common_1.Id,
    model: effect_1.Schema.optionalWith(common_1.ModelCode, { exact: true }),
    dismissedAt: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }).annotations({
        description: 'Entity dismissing date',
    }),
    dismissedBy: effect_1.Schema.optionalWith(User.Id, { exact: true }).annotations({
        description: 'User ID who dismissed manually',
    }),
})).annotations({
    identifier: `${exports.NAMESPACE}.Alarm`,
    description: 'Item from the history of alarms occurred on a device',
});
exports.Event = effect_1.Schema.Struct({
    event: EventCapability.Event,
    id: EventCapability.Id,
    deviceId: common_1.Id,
    createdAt: entity_1.CreatedAt,
}).annotations({
    identifier: `${exports.NAMESPACE}.Event`,
    description: 'Item from the history of events occurred on a device',
});
exports.OtaUpdate = effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    jobId: Job.Job.fields.id,
    deviceId: common_1.Id,
    status: Job.Job.fields.status,
    buildFile: Ota.Build.fields.buildFile,
    targetVersion: Ota.Build.fields.version,
    previousVersion: Job.TaskParamsOta.fields.previousVersion,
    lastAttemptAt: effect_1.Schema.propertySignature(date_1.DateFromUtcIsoDateString).annotations({
        description: 'Update last attempt date',
    }),
    deliveredAt: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString)).annotations({
        description: 'Update delivering date',
    }),
    completedAt: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString)).annotations({
        description: 'Update completing date',
    }),
    log: effect_1.Schema.NullOr(Job.Log),
})).annotations({
    identifier: `${exports.NAMESPACE}.OtaUpdate`,
    description: 'Item from the history of OTA updates targeting a device',
});
const BaseHistoryConnectionEvent = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    deviceId: common_1.Id,
    region: Azure.MacroRegion,
    createdAt: entity_1.CreatedAt,
}).annotations({
    identifier: `${exports.NAMESPACE}.BaseHistoryConnectionEvent`,
    description: 'Base attributes for a history connection event.',
});
const Connected = BaseHistoryConnectionEvent.pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
    online: effect_1.Schema.Literal(true),
    source: effect_1.Schema.optionalWith(effect_1.Schema.Literal('data', 'event'), {
        exact: true,
        default: () => 'event',
    }).annotations({
        description: 'Source of the event, either inferred by data receival or by explicit event',
    }),
}))).annotations({
    identifier: `${exports.NAMESPACE}.Connected`,
    description: 'A device connection event detected in a point in time.',
});
const Disconnected = BaseHistoryConnectionEvent.pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
    online: effect_1.Schema.Literal(false),
    source: effect_1.Schema.optionalWith(effect_1.Schema.Literal('timeout', 'event'), {
        exact: true,
        default: () => 'event',
    }).annotations({
        description: 'Source of the event, either inferred by timeout expiration or by an explicit event',
    }),
}))).annotations({
    identifier: `${exports.NAMESPACE}.Disconnected`,
    description: 'A device disconnection event detected in a point in time.',
});
exports.ConnectionHistoryEvent = effect_1.Schema.Union(Connected, Disconnected).annotations({
    identifier: `${exports.NAMESPACE}.ConnectionHistoryEvent`,
    description: 'Event triggered when a device connects or is detected as disconnected by the cloud.',
});
exports.Telemetry = effect_1.Schema.Union(...effect_1.Array.map(effect_1.Record.values(class_1.models), model => effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    deviceId: common_1.Id,
    model: effect_1.Schema.tag(model.code),
    telemetries: model.fields.latestTelemetry,
    time: effect_1.Schema.DateFromNumber,
    metadata: effect_1.Schema.Struct({
        region: effect_1.Schema.NullOr(Azure.MacroRegionCode),
    }),
})))).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
    description: 'Item from the history of telemetries sent by a device',
});
//# sourceMappingURL=history.js.map